// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"7f764cfa16d4fd96bdba","339":"e12ed33fe5ff59ff0660"}[chunkId] + ".js";
};